import React, {Component} from 'react'

class Graph extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {

    return (
      <div>
        hello
      </div>
    )
  }
}

export default Graph
